/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CurrencyResponseDto } from './CurrencyResponseDto';
import {
    CurrencyResponseDtoFromJSON,
    CurrencyResponseDtoFromJSONTyped,
    CurrencyResponseDtoToJSON,
    CurrencyResponseDtoToJSONTyped,
} from './CurrencyResponseDto';

/**
 * 
 * @export
 * @interface BankAccountResponseDto
 */
export interface BankAccountResponseDto {
    /**
     * 
     * @type {number}
     * @memberof BankAccountResponseDto
     */
    accountNumber: number;
    /**
     * 
     * @type {string}
     * @memberof BankAccountResponseDto
     */
    accountName: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountResponseDto
     */
    bankCode: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountResponseDto
     */
    currencyCode: string;
    /**
     * 
     * @type {CurrencyResponseDto}
     * @memberof BankAccountResponseDto
     */
    currency?: CurrencyResponseDto;
}

/**
 * Check if a given object implements the BankAccountResponseDto interface.
 */
export function instanceOfBankAccountResponseDto(value: object): value is BankAccountResponseDto {
    if (!('accountNumber' in value) || value['accountNumber'] === undefined) return false;
    if (!('accountName' in value) || value['accountName'] === undefined) return false;
    if (!('bankCode' in value) || value['bankCode'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    return true;
}

export function BankAccountResponseDtoFromJSON(json: any): BankAccountResponseDto {
    return BankAccountResponseDtoFromJSONTyped(json, false);
}

export function BankAccountResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankAccountResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'accountNumber': json['accountNumber'],
        'accountName': json['accountName'],
        'bankCode': json['bankCode'],
        'currencyCode': json['currencyCode'],
        'currency': json['currency'] == null ? undefined : CurrencyResponseDtoFromJSON(json['currency']),
    };
}

export function BankAccountResponseDtoToJSON(json: any): BankAccountResponseDto {
    return BankAccountResponseDtoToJSONTyped(json, false);
}

export function BankAccountResponseDtoToJSONTyped(value?: BankAccountResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accountNumber': value['accountNumber'],
        'accountName': value['accountName'],
        'bankCode': value['bankCode'],
        'currencyCode': value['currencyCode'],
        'currency': CurrencyResponseDtoToJSON(value['currency']),
    };
}

